import createUICardElement from "backend/utils/createUICardElement";
import * as wf from "client-api-workflow";
import { useQuery } from "react-query";

const useWorkflowConfigurations = () => {
  return useQuery(
    JSON.stringify(["workflow-configurations"]),
    () => {
      return wf.getWorkflowConfigurations().then((items) => {
        return items.map((item) =>
          createUICardElement(item._id || "", "workflowconfig", item)
        );
      });
    },
    {
      cacheTime: 10 * 60 * 1000,
    }
  );
};

export default useWorkflowConfigurations;
